export class LatinKiller {
    // remover acento e caracteres especiais
    public static kill(value: string): string {
        if (!value) return "";
        return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }
}